import { FIBER_POP_UPLOAD_EXCEL } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const uploadFiberPopExcelFile = async (formData) => {
  try {
    const response = await apiClient.post(FIBER_POP_UPLOAD_EXCEL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
